import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type AuthShellProps = {
  badge: string;
  children: ReactNode;
  description: string;
  eyebrow?: string;
  title: string;
};

export function AuthShell({
  badge,
  children,
  description,
  eyebrow,
  title,
}: AuthShellProps) {
  return (
    <main className="relative min-h-screen overflow-hidden bg-[linear-gradient(180deg,#f7f8fa_0%,#eff3f6_100%)] text-foreground dark:bg-[linear-gradient(180deg,#11161d_0%,#0a0f15_100%)]">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(14,165,233,0.10),transparent_28%),radial-gradient(circle_at_bottom_right,rgba(15,118,110,0.10),transparent_30%)]" />
      <div className="relative mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center px-6 py-12">
        <section className="grid w-full items-center gap-10 lg:grid-cols-[1.08fr_0.92fr]">
          <div className="hidden lg:block">
            <div className="max-w-xl space-y-8">
              <div className="flex items-center gap-4">
                <div className="flex h-20 w-44 items-center justify-center rounded-2xl bg-white px-4 py-3 shadow-sm ring-1 ring-border/50">
                   <img src="/logo-mutuale.png" alt="Mutuale Logo" className="h-full w-auto object-contain" />
                </div>
                <span className="inline-flex items-center rounded-full border border-border/60 bg-background/80 px-3 py-1 text-xs font-semibold tracking-[0.18em] text-primary uppercase shadow-sm">
                  {eyebrow || 'Gestion des Salons'}
                </span>
              </div>
              <div className="space-y-4">
                <h1 className="max-w-lg text-5xl leading-tight font-bold tracking-tight text-foreground">
                  {title}
                </h1>
                <p className="max-w-xl text-lg leading-relaxed text-muted-foreground">
                  {description}
                </p>
              </div>
            </div>
          </div>
          <div className="rounded-[var(--radius-surface-4xl)] border border-border/70 bg-card/85 p-8 shadow-[0_30px_80px_rgba(15,23,42,0.08)] backdrop-blur">
            <div className="mb-6 flex items-center justify-center">
              <span className={cn('inline-flex items-center rounded-full border border-border/70 bg-background/80 px-3 py-1 text-xs font-medium tracking-[0.18em] text-muted-foreground uppercase')}>
                {badge}
              </span>
            </div>
            {children}
          </div>
        </section>
      </div>
    </main>
  );
}
